import { Button, Flex, useStyles } from '@archipro-design/aria';
import * as S from './DesignBoardConfirmation.style';

interface LeaveBoardModalProps {
    headerText: string;
    bodyText: string;
    confirmationText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const LeaveBoardModal = ({
    headerText,
    bodyText,
    confirmationText = 'CONFIRM',
    cancelText = 'CANCEL',
    onConfirm,
    onCancel,
}: LeaveBoardModalProps) => {
    const { css } = useStyles();

    return (
        <>
            <div className={css(S.DesignBoardModalHeader)}>{headerText}</div>
            <div className={css(S.DesignBoardModalBody)}>{bodyText}</div>
            <Flex gap="space-8" hAlign="end">
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    color="dark"
                    size={16}
                    className={css(S.DesignBoardModalButton)}
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    size={16}
                    className={css(S.DesignBoardModalButton)}
                >
                    {confirmationText}
                </Button>
            </Flex>
        </>
    );
};

export default LeaveBoardModal;
